import Navbar from '../components/Navbar/Navbar';
import Footer from '../sections/Footer/Footer';
import KnowYourDr from '../sections/KnowYourDr/DoctorProfile';

const KnowYourDrPage = () =>{
    return(
        <>
        <Navbar />
        <KnowYourDr />
        <Footer />        
        </>
    )
}
export default KnowYourDrPage;